import * as React from "react";
import { ComboBox } from "@/components/ui/combo-box";
import type { InvoicePublic } from "./schema";

interface InvoiceData {
  data?: InvoicePublic[];
}

type YearValue = number;

interface SelectYearComboBoxProps {
  value: YearValue | null;
  onChange: (value: YearValue | null) => void;
  data: InvoiceData | undefined;
  isLoading?: boolean;
  placeholder?: string;
  triggerClassName?: string;
  contentClassName?: string;
}

export function SelectYearComboBox({
  value,
  onChange,
  data,
  placeholder = "Year",
  isLoading = false,
  triggerClassName,
  contentClassName,
}: SelectYearComboBoxProps) {
  const years = React.useMemo(() => {
    if (!data?.data) return [];
    const uniqueYears = new Set(data.data.map((invoice) => invoice.year).filter(Boolean));
    return Array.from(uniqueYears)
      .sort((a, b) => b - a) // Sort years descending (most recent first)
      .map((year) => ({
        value: year,
        label: year.toString(),
      }));
  }, [data]);

  return (
    <ComboBox<YearValue>
      options={years}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search year..."
      emptyMessage="No year found."
      isLoading={isLoading || !data}
      triggerClassName={triggerClassName}
      contentClassName={contentClassName}
      allowClear
    />
  );
}
